import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { T } from "@/context/LanguageContext";

const COLS = [
  { h: "Explore", links: ["States", "Regions", "Territories", "Counties", "Cities & Towns", "Instant Cities", "Interactive Atlas"] },
  { h: "Discover", links: ["People", "History", "Culture", "Compare Symbols", "Flags of America", "Nature"] },
  { h: "By the Numbers", links: ["Population", "Economy", "Education", "Healthcare", "Government", "Data"] },
  { h: "Pulse Network", links: ["WeatherPulse", "SciencePulse", "NaturePulse", "FarmersPulse", "Partner Portal", "Licensing"] },
];

const FOOTER_LINK = {
  "Instant Cities": "/cities",
  "Interactive Atlas": "/atlas",
  "Regions": "/explore/states?group=historical",
  "Compare Symbols": "/symbols/compare",
  "Flags of America": "/flags",
  "People": "/people",
};

export function SiteFooter() {
  return (
    <footer className="bg-navy-deep text-white/80">
      <div className="mx-auto max-w-[1500px] px-4 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-1">
            <div className="inline-block max-w-full rounded-lg bg-white/95 p-3"><Logo compact /></div>
            <p className="mt-4 max-w-xs text-sm text-white/60">
              <T>A living digital knowledge network for the United States — every state, county, community and place, with its people, history and data.</T>
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.h}>
              <h4 className="mb-3 font-display text-lg font-semibold text-white"><T>{c.h}</T></h4>
              <ul className="space-y-2 text-sm">
                {c.links.map((l) => (
                  <li key={l}>
                    <Link to={FOOTER_LINK[l] || "/explore/states"} className="transition-colors hover:text-white" data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                      <T>{l}</T>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row">
          <span>© 2026 USAPulse.net · <T>Explore America. Understand America. Connect with America.</T></span>
          <div className="flex gap-5">
            <span><T>Sources & Attribution</T></span>
            <span><T>Privacy</T></span>
            <span><T>Terms</T></span>
          </div>
        </div>
      </div>
    </footer>
  );
}
